import React, { Component } from 'react'
import './home.css';
import './media-query.css';
import Hero from './HeroSection';
import Service from './ServiceSection';
import Recruit from './RecruitSection';
import Bottom from './BottomSection';
import { Helmet } from "react-helmet-async";
import lpButton from '../../assets/images/landingPage/lp-home-button.jpg'

const MyReactComponent = (props) =>
    <div className="lp-home-pop">
         {/*<button className="lp-home-btn" onClick={props.onClose}>
        </button>
        <a href="/lp" target="_blank">
            <img src={lpButton} alt="landing-page" />
        </a>*/}
    </div>;
class Home extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
    }

    closeChild = () => {
        this.setState({
            showChild: false
        });
    };
    constructor(...args) {
        super(...args);
        this.state = {
            showChild: true
        };
    }

    render() {
        return (
            <React.Fragment>
                <Helmet>
                    <title>NAL | 日本アドバンストリーダーズソフトウェア株式会社</title>
                </Helmet>
                <div className="home-container">
                    {this.state.showChild && <MyReactComponent onClose={this.closeChild} />}
                    <Hero />
                    <Service />
                    <Recruit />
                    {/* <Cards /> */}
                    <Bottom />
                </div>
            </React.Fragment>
        )
    }
}

export default Home;